import styled from 'styled-components'

export const Wrapper = styled.div`
	padding: 1.5rem 0;
	display: flex;
	align-items: center;
	justify-content: space-between;

	a {
		color: #212121;
	}
`
export const Brand = styled.div`
	display: flex;
	align-items: center;
	color: #212121;
`

export const BrandLogo = styled.div`
	transition: 0.5s;
	height: 2rem;
	width: 2.8rem;
	margin-bottom: 0;
	margin-right: 0.5rem;
`
